import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  private readonly baseUserUrl = `${environment.serverUrl}/api/support`;
  constructor(private httpClient: HttpClient) {}
  public createTrainingSet(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpClient.put(this.baseUserUrl, '').subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        },
      );
    });
  }

  public deleteTrainingSets(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpClient.delete(this.baseUserUrl).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        },
      );
    });
  }
}
